import React, { useState } from 'react';
import {
  Box, FormControl, Grid, MenuItem, Select,
  TextField, Typography, CircularProgress
} from '@mui/material';
import { ArrowRightAlt } from '@mui/icons-material';
import axios from 'axios';
import toast from 'react-hot-toast';
import { API } from '../../../utils/Api';

const EnquiryForm = () => {
  const [form, setForm] = useState({
    name: '',
    mobile: '',
    email: '',
    investmentAmount: '',
    cityAndState: '',
    whereYouHeardAboutUs: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const validate = () => {
    if (!form.name.trim()) return 'Please enter your name.';
    if (!/^\d{10}$/.test(form.mobile)) return 'Please enter a valid 10-digit mobile number.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return 'Please enter a valid email.';
    if (!form.investmentAmount) return 'Please select an investment amount.';
    if (!form.cityAndState.trim()) return 'Please enter your city and state.';
    if (!form.whereYouHeardAboutUs) return 'Please select an option.';
    return null;
  };

  const handleSubmit = async () => {
    const error = validate();
    if (error) {
      toast.error(error);
      return;
    }
    console.log('form', form);
    
    try {
      setLoading(true);
      const res = await axios.post(`${API.BASE_URL}franchise-enquiry`, form);
      toast.success('Enquiry submitted successfully!');
      setForm({ name: '', mobile: '', email: '', investmentAmount: '' });
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="franchiseEnquiry">
      <Typography className="franchiseEnquiryTitle" fontWeight={'500'}>Join the Smart Coffee Movement</Typography>
      <Typography className="franchiseEnquiryPara" fontWeight={'400'}>Fill out the form and let's get started</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Grid container md={7} spacing={4} display={'flex'} justifyContent={'center'}>
          <Grid item xs={10} md={6}>
            <TextField
              placeholder="Name"
              value={form.name}
              onChange={handleChange('name')}
              fullWidth
              sx={textFieldStyle}
              InputProps={{ sx: inputStyle }}
            />
          </Grid>
          <Grid item xs={10} md={6}>
            <TextField
              placeholder="Mobile"
              value={form.mobile}
              onChange={handleChange('mobile')}
              fullWidth
              sx={textFieldStyle}
              InputProps={{ sx: inputStyle }}
            />
          </Grid>
          <Grid item xs={10} md={6}>
            <TextField
              placeholder="Email"
              value={form.email}
              onChange={handleChange('email')}
              fullWidth
              sx={textFieldStyle}
              InputProps={{ sx: inputStyle }}
            />
          </Grid>
          <Grid item xs={10} md={6}>
            <FormControl fullWidth sx={{ backgroundColor: '#fff', borderRadius: '5px' }}>
              <Select
                value={form.investmentAmount}
                onChange={handleChange('investmentAmount')}
                displayEmpty
                sx={{
                  height: 40,
                  fontSize: '14px',
                  textAlign: 'start',
                }}
                renderValue={(selected) =>
                  selected ? selected : <span style={{ color: '#000', fontWeight: 500 }}>Investment Amount</span>
                }
              >
                <MenuItem disabled>Investment Amount</MenuItem>
                <MenuItem value="Upto 25 Lakhs">Upto 25 Lakhs</MenuItem>
                <MenuItem value="50 Lakhs to 1 Crore">50 Lakhs to 1 Crore</MenuItem>
                <MenuItem value="1 Crore +">1 Crore +</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={10} md={6}>
            <TextField
              placeholder="City and State"
              value={form.cityAndState}
              onChange={handleChange('cityAndState')}
              fullWidth
              sx={textFieldStyle}
              InputProps={{ sx: inputStyle }}
            />
          </Grid>
          <Grid item xs={10} md={6}>
            <FormControl fullWidth sx={{ backgroundColor: '#fff', borderRadius: '5px' }}>
              <Select
                value={form.whereYouHeardAboutUs}
                onChange={handleChange('whereYouHeardAboutUs')}
                displayEmpty
                sx={{
                  height: 40,
                  fontSize: '14px',
                  textAlign: 'start',
                }}
                renderValue={(selected) =>
                  selected ? selected : <span style={{ color: '#000', fontWeight: 500 }}>Where did you hear about us?</span>
                }
              >
                <MenuItem disabled>Where did you hear about us?</MenuItem>
                <MenuItem value="App / Website">App / Website</MenuItem>
                <MenuItem value="From a friend">From a friend</MenuItem>
                <MenuItem value="Social Media">Social Media</MenuItem>
                <MenuItem value="Visited Cafe">Visited Cafe</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={10} md={7}>
            <Box
              className="sendEnquiryButton"
              onClick={handleSubmit}
              sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            >
              {loading ? (
                <CircularProgress size={20} sx={{ color: '#fff' }} />
              ) : (
                <>
                  <p style={{ margin: 0 }}>Send Enquiry</p>
                  <ArrowRightAlt className='sendEnquiryButtonIcon' />
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </section>
  );
};

// Shared styles
const textFieldStyle = {
  backgroundColor: '#fff',
  borderRadius: '5px',
  '& input::placeholder': {
    color: '#000',
    fontWeight: 500,
    opacity: 1,
  },
};

const inputStyle = {
  height: 40,
  fontSize: '14px',
  alignItems: 'center',
  justifyContent: 'center',
};

export default EnquiryForm;
